import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {RolleCheckboxWrapper} from '../../veranstaltungen/veranstaltungen.page';
import {select, Store} from '@ngrx/store';
import {LoadingController, ModalController} from '@ionic/angular';
import * as fromReducer from './dokument-verwaltung-berechtigungen.reducer';
import * as actionsUi from './dokument-verwaltung-berechtigungen.actions.ui';
import {
    Dokument,
    DokumentBerechtigung,
    DokumentBerechtigungRolleMultiRequest,
} from '../../../../clients/vorlagen';
import {
    GetDokumentBerechtigungAction,
    PostDokumentBearbeitenBerechtigungEntfernenMultiAction,
    PostDokumentBearbeitenBerechtigungHinzufuegenMultiAction,
    PostDokumentBerechtigungEntfernenMultiAction,
    PostDokumentBerechtigungHinzufuegenMultiAction,
} from '../../../../client-ngrx/vorlagen';
import {Datenquelle} from '../../rollenselektion/rollenselektion.model';
import {RollenselektionPage} from '../../rollenselektion/rollenselektion.page';

@Component({
    selector: 'app-dokument-verwaltung-berechtigungen',
    templateUrl: './dokument-verwaltung-berechtigungen.page.html',
    styleUrls: ['./dokument-verwaltung-berechtigungen.page.scss'],
})
export class DokumentVerwaltungBerechtigungenPage implements OnInit {
    @Input() aktuellesDokument$: Observable<Dokument> = null;

    berechtigungRollen: Array<RolleCheckboxWrapper> = [];
    bearbeitenBerechtigungRollen: Array<RolleCheckboxWrapper> = [];
    dokumentberechtigungRolleEntfernenAktiv: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    dokumentberechtigungRolleEntfernenAktiv$: Observable<boolean>;
    dokumentBearbeitenBerechtigungRolleEntfernenAktiv: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    dokumentBearbeitenBerechtigungRolleEntfernenAktiv$: Observable<boolean>;

    dokumentBerechtigung$: Observable<DokumentBerechtigung>;
    dokumentBerechtigungLaden$: Observable<boolean>;
    dokumentBerechtigungFehler$: Observable<boolean>;

    aktuellesDokument: Dokument = null;

    dokumentDetailSubscription: Subscription;

    constructor(public modalCtrl: ModalController,
                private store: Store<fromReducer.PageState>,
                public loadingCtrl: LoadingController) {
        this.dokumentberechtigungRolleEntfernenAktiv$ = this.dokumentberechtigungRolleEntfernenAktiv.asObservable();
        this.dokumentBearbeitenBerechtigungRolleEntfernenAktiv$ = this.dokumentBearbeitenBerechtigungRolleEntfernenAktiv.asObservable();
    }

    // ionViewDidLoad() {
    ngOnInit() {
        this.store.dispatch(new actionsUi.PageStateResetAction());

        this.dokumentBerechtigung$ = this.store.pipe(select(fromReducer.getDokumentBerechtigung));
        this.dokumentBerechtigungLaden$ = this.store.pipe(select(fromReducer.getDokumentBerechtigungLaden));
        this.dokumentBerechtigungFehler$ = this.store.pipe(select(fromReducer.getDokumentBerechtigungFehler));

        // TODO Die Subscription hier muss anders gelöst werden. Idee: Das kann vlt. alles über einen Selektor geschehen.
        this.dokumentDetailSubscription = this.aktuellesDokument$.subscribe((x: Dokument) => {
            console.log('Aktuelles Dokument: ', x);
            if (x != null) {
                if (x.berechtigung_rolle_liste !== null && x.berechtigung_rolle_liste !== undefined) {
                    this.berechtigungRollen = x.berechtigung_rolle_liste.map((fbRolle) => {
                        return <RolleCheckboxWrapper>{
                            rolle: fbRolle.rolle,
                            titel: fbRolle.rolle.titel,
                            fbTitel: fbRolle.funktionsbereich.titel,
                            selected: false
                        };
                    });
                } else {
                    this.berechtigungRollen = [];
                }

                console.log(this.berechtigungRollen);
                if (x.bearbeiten_berechtigung_rolle_liste !== null && x.bearbeiten_berechtigung_rolle_liste !== undefined) {
                    this.bearbeitenBerechtigungRollen = x.bearbeiten_berechtigung_rolle_liste.map((fbRolle) => {
                        return <RolleCheckboxWrapper>{
                            rolle: fbRolle.rolle,
                            titel: fbRolle.rolle.titel,
                            selected: false,
                            fbTitel: fbRolle.funktionsbereich.titel
                        };
                    });
                } else {
                    this.bearbeitenBerechtigungRollen = [];
                }
                console.log(this.bearbeitenBerechtigungRollen);

                this.aktuellesDokument = x;
            } else {
                this.aktuellesDokument = null;
            }
            this.store.dispatch(new GetDokumentBerechtigungAction(x.dokument_id));
        });
    }

    async leseBerechtigungRollenAuswahl() {
        if (this.aktuellesDokument != null &&
            this.aktuellesDokument.titel !== null && this.aktuellesDokument.titel !== '' &&
            this.aktuellesDokument.dateiname !== null && this.aktuellesDokument.dateiname !== '') {
            const params = {
                titel: 'Dokument Lese Berechtigung',
                nichtAnzuzeigendeRollenIds: this.aktuellesDokument.berechtigung_rollen_ids,
                funktionsbereich: null,
                checkliste: null,
                untertitel: this.aktuellesDokument.titel,
                aktuellesDokument: this.aktuellesDokument,
                alleAnzeigenAuswahlAnzeigen: false,
                alleAnzeigen: true,
                datenquelle: Datenquelle.Vorlagen
            };
            const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                    if (result != null && result.data) {
                        const data = result.data;
                        const rolleIds = [];
                        data.ausgewaehlteRollen.forEach((rolleId) => {
                            rolleIds.push(rolleId);
                        });
                        const request = <DokumentBerechtigungRolleMultiRequest>{
                            dokument_id: this.aktuellesDokument.dokument_id,
                            rolle_ids: rolleIds
                        };

                        this.store.dispatch(new PostDokumentBerechtigungHinzufuegenMultiAction(request));
                    }
                }
            );

            await modal.present();
        }
    }

    async berechtigungRollenEntfernenAktiviertDeaktiviert() {
        const rollenIds = this.berechtigungRollen.filter((rolle) => {
            return rolle.selected === true;
        }).map((rolle) => {
            return rolle.rolle.rolle_id;
        });
        if (rollenIds.length > 0) {
            this.dokumentberechtigungRolleEntfernenAktiv.next(true);
        } else {
            this.dokumentberechtigungRolleEntfernenAktiv.next(false);
        }
    }

    async bearbeitenBerechtigungRollenAuswahl() {
        if (this.aktuellesDokument != null &&
            this.aktuellesDokument.titel !== null && this.aktuellesDokument.titel !== '' &&
            this.aktuellesDokument.dateiname !== null && this.aktuellesDokument.dateiname !== '') {
            const params = {
                titel: 'Dokument Bearbeiten Berechtigung',
                nichtAnzuzeigendeRollenIds: this.aktuellesDokument.bearbeiten_berechtigung_rollen_ids,
                funktionsbereich: null,
                checkliste: null,
                untertitel: this.aktuellesDokument.titel,
                aktuellesDokument: this.aktuellesDokument,
                alleAnzeigenAuswahlAnzeigen: false,
                alleAnzeigen: true,
                datenquelle: Datenquelle.Vorlagen
            };
            const modal = await this.modalCtrl.create({component: RollenselektionPage, componentProps: params});
            modal.onDidDismiss().then((result: any) => {
                    if (result != null && result.data) {
                        const data = result.data;
                        const rolleIds = [];
                        data.ausgewaehlteRollen.forEach((rolleId) => {
                            rolleIds.push(rolleId);
                        });
                        const request = <DokumentBerechtigungRolleMultiRequest>{
                            dokument_id: this.aktuellesDokument.dokument_id,
                            rolle_ids: rolleIds
                        };

                        this.store.dispatch(new PostDokumentBearbeitenBerechtigungHinzufuegenMultiAction(request));
                    }
                }
            );

            await modal.present();
        }
    }

    async bearbeitenBerechtigungRollenEntfernenAktiviertDeaktiviert() {
        const rollenIds = this.bearbeitenBerechtigungRollen.filter((rolle) => {
            return rolle.selected === true;
        }).map((rolle) => {
            return rolle.rolle.rolle_id;
        });
        if (rollenIds.length > 0) {
            this.dokumentBearbeitenBerechtigungRolleEntfernenAktiv.next(true);
        } else {
            this.dokumentBearbeitenBerechtigungRolleEntfernenAktiv.next(false);
        }
    }

    async dokumentberechtigungRolleEntfernen() {
        const rollenIds = this.berechtigungRollen.filter((rolle) => {
            return rolle.selected === true;
        }).map((rolle) => {
            return rolle.rolle.rolle_id;
        });

        const request = <DokumentBerechtigungRolleMultiRequest>{
            dokument_id: this.aktuellesDokument.dokument_id,
            rolle_ids: rollenIds
        };

        this.store.dispatch(new PostDokumentBerechtigungEntfernenMultiAction(request));
        this.dokumentberechtigungRolleEntfernenAktiv.next(false);
    }

    async dokumentBearbeitenBerechtigungRolleEntfernen() {
        const rollenIds = this.bearbeitenBerechtigungRollen.filter((rolle) => {
            return rolle.selected === true;
        }).map((rolle) => {
            return rolle.rolle.rolle_id;
        });

        const request = <DokumentBerechtigungRolleMultiRequest>{
            dokument_id: this.aktuellesDokument.dokument_id,
            rolle_ids: rollenIds
        };

        this.store.dispatch(new PostDokumentBearbeitenBerechtigungEntfernenMultiAction(request));
        this.dokumentBearbeitenBerechtigungRolleEntfernenAktiv.next(false);
    }

    ionViewDidLeave() {
        if (this.dokumentDetailSubscription) {
            this.dokumentDetailSubscription.unsubscribe();
        }
    }
}
